<template>
    <div>
        <div class="row">
            <div class="col-md-6 mb-1">
                <label class="form-label">Alt Limit (TL) <span class="text-danger">*</span></label>
                <v-validator parameter="min" :errors="errors" :watch="value.min">
                    <input v-model.number="value.min" type="number" class="form-control" placeholder="Alt limit" />
                </v-validator>
            </div>
            <div class="col-md-6 mb-1">
                <label class="form-label">Üst Limit (TL)</label>
                <v-validator parameter="max" :errors="errors" :watch="value.max">
                    <input v-model.number="value.max" type="number" class="form-control" placeholder="Üst limit" />
                </v-validator>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-1">
                <label class="form-label">Onay Verecek Kişi</label>
                <v-validator parameter="approverUserId" :errors="errors" :watch="value.approverUserId">
                    <v-select-list v-model="approverUser" :options="users" label="displayText" placeholder="Kişi seçin" />
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Bilgilendirilecek Kişiler</label>
                <v-validator parameter="userIdsToInform" :errors="errors" :watch="value.userIdsToInform">
                    <v-select-list v-model="informUsers" :options="users" label="displayText" placeholder="Kişi seçin" multiple />
                </v-validator>
            </div>
        </div>
    </div>
</template>

<script>
import UserApi from "@/api/user";
import { BFormCheckbox } from "bootstrap-vue";

export default {
    components: {
        BFormCheckbox,
    },
    props: {
        value: { type: Object, required: true },
        errors: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            users: [],
        };
    },
    mounted() {
        this.getUsers();
    },
    methods: {
        getUsers() {
            UserApi.ListUser().then((response) => {
                const userData = response.data.Data || [];
                this.users = userData.map((u) => ({
                    ...u,
                    displayText: u.UserFullName+' ('+u.Username+')'
                }));
            });
        },
    },
    computed: {
        approverUser: {
            get() {
                if (!this.value || this.users.length === 0) return null;
                return this.users.find((u) => u.Id === this.value.approverUserId);
            },
            set(user) {
                this.value.approverUserId = user?.Id || null;
            },
        },
        informUsers: {
            get() {
                if (!this.value || !this.value.userIdsToInform || this.users.length === 0) return [];
                return this.users.filter((u) => this.value.userIdsToInform.includes(u.Id));
            },
            set(selectedUsers) {
                const usersAsArray = Array.isArray(selectedUsers) ? selectedUsers : selectedUsers ? [selectedUsers] : [];

                this.value.userIdsToInform = usersAsArray.map((u) => u.Id);
            },
        },
    },
};
</script>
